import FilterTab2 from "../../../components/common/FilterTab2";
import TyperComponent from "../../../components/common/Typer";
import { sliderImages } from "../../../data/heroSlides";
import React, { useEffect } from "react";
import graphlicImage from '../../../images/slider/graplic-slider-2.png'
import { Autoplay, EffectFade } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { getAllHeroTitlenandSubtitle } from "../../../APIs/APIHelperforWeb";
import { BaseURL } from "../../../APIs/APIUrls";

export default function Hero({ setLocationName, LocationName }) {

 


  const [objHeroSectionList, setHeroSectionList] = React.useState([]);
  const [Titles, setTitles] = React.useState([]);
  const [SubTitles, setSubTitles] = React.useState([]);
  const [Images, setImages] = React.useState([]);
  const subtitleIntervalRef = React.useRef(null);
  const swiperRef = React.useRef(null);

  const asArray = (value) => (Array.isArray(value) ? value : []);

  useEffect(() => {
    const fetchHeroData = async () => {
      const storedData = localStorage.getItem('HeroSectionListforWeb');
      const timeStamp = JSON.parse(localStorage.getItem('TimeStampforData')) || 0;
      const currentTime = new Date().getTime();
      const dataExpired = currentTime > timeStamp;

      if (!storedData || dataExpired) {
        await getAllHeroTitlenandSubtitle();
      }
      let data = [];
      try {
        data = asArray(JSON.parse(localStorage.getItem('HeroSectionListforWeb')) || []);
      } catch (error) {
        data = [];
      }

      setHeroSectionList(data);


      let titles = asArray(data).map(item => item?.Title).filter(Boolean);
      let subTitles = asArray(data).map(item => item?.SubTitle).filter(Boolean);
      let images = asArray(data)
        .flatMap(item => asArray(item?._lstBannerSection))
        .map(item => ({
          Image: item?.Image,
          Title: item?.Title,
        }))
        .filter(item => item?.Image);
     console.log("Fetched Hero Data:", { titles, subTitles, images });  
      setImages(images);
      setTitles(titles);
      console.log("Fetched Hero Data:", { titles, subTitles, images });
      handleMainTitle(subTitles);

    };

    fetchHeroData();

    return () => {
      if (subtitleIntervalRef.current) {
        clearInterval(subtitleIntervalRef.current);
      }
    };
  }, []);

    // Helper to resolve image source URLs safely
    const resolveImageSrc = (imagePath = "") => {
      const val = String(imagePath || "").trim();
      if (!val) return "";
      if (/^https?:\/\//i.test(val) || val.startsWith("data:")) {
        return val;
      }
      const normalized = val.startsWith("/") ? val : `/${val}`;
      return `${BaseURL.replace(/\/+$/, "")}${normalized}`;
    };

    // Ensure Swiper updates after images change
    React.useEffect(() => {
      console.log("Hero images count:", asArray(Images).length, Images);
      asArray(Images).forEach((img, i) => console.log(`Resolved hero image [${i}]:`, resolveImageSrc(img.Image)));
      if (swiperRef.current && typeof swiperRef.current.update === 'function') {
        // slight timeout to allow DOM to settle
        setTimeout(() => {
          try {
            swiperRef.current.update();
            console.log('Called swiper.update()');
          } catch (e) {
            console.warn('swiper.update() failed', e);
          }
        }, 50);
      }

      
    }, [Images]);

  function handleMainTitle(_Titles) {
    if (!Array.isArray(_Titles) || _Titles.length === 0) {
      setSubTitles([]);
      return;
    }

    let currentIndex = 0;
    setSubTitles([_Titles[currentIndex]]);

    if (subtitleIntervalRef.current) {
      clearInterval(subtitleIntervalRef.current);
    }

    subtitleIntervalRef.current = setInterval(() => {
      currentIndex = (currentIndex + 1) % _Titles.length;
      setSubTitles([_Titles[currentIndex]]);
    }, 3100);

    return _Titles[0];
  }




  return (
    <section className="flat-slider home-2 bg-primary-new">
      <div className="container relative">
        <div className="row">
          <div className="col-xl-10">
            <div className="slider-content">
              <div className="heading">
                <h1 className="fw-8 title animationtext clip">
                  Find A Home That
                  <br />
                  <TyperComponent
                    strings={Array.isArray(Titles) && Titles.length > 0 ? Titles : ["Fits Perfectly", "Fits Dream Home"]}
                  />
                </h1>
                <p
                  className="subtitle body-2 wow fadeInUp"
                  data-wow-delay=".2s"
                >
                  {Array.isArray(SubTitles) && SubTitles.length > 0 ? SubTitles[0] : "We are a real estate agency that will help you find the best residence you dream of."}
                </p>
              </div>

              <FilterTab2 tabClass="nav-tab-form style-2" styleClass="style-2" setLocationName={setLocationName} LocationName={LocationName} />
              <div className="wrap-search-link">
                <p className="body-2">What are you looking for:</p>
                <div className="categories-list">
                  <a href="#">
                    <i className="icon icon-house-fill" /> Houses
                  </a>
                  <a href="#">
                    <i className="icon icon-villa-fill" /> Villa
                  </a>
                  <a href="#">
                    <i className="icon icon-office-fill" /> Office
                  </a>
                  <a href="#">
                    <i className="icon icon-apartment" /> Apartments
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="img-banner-right">
        {/* {console.log("Hero images count:", asArray(Images).length, Images)} */}
        {asArray(Images).length > 0 && (
          <Swiper
            effect="fade"
            fadeEffect={{ crossFade: true }}
            modules={[EffectFade, Autoplay]}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop={asArray(Images).length > 1}
            slidesPerView={1}
            observer={true}
            observeParents={true}
            resizeObserver={true}
            watchOverflow={true}
            onSwiper={(s) => { swiperRef.current = s; console.log('onSwiper slides=', s.slides.length); }}
            onInit={(swiper) => console.log('Swiper init slides=', swiper.slides.length, 'isBeginning=', swiper.isBeginning, 'isEnd=', swiper.isEnd)}
            onUpdate={(swiper) => console.log('Swiper update slides=', swiper.slides.length, 'activeIndex=', swiper.activeIndex)}
            speed={500}
            className="swiper slider-sw-home2"
            key={asArray(Images).map((image) => image.Image).join("|")}
          >
            {asArray(Images).map((image, index) => {
              const src = resolveImageSrc(image.Image);
              console.log(`Resolved hero image [${index}]:`, src);
              return (
              
              <SwiperSlide className="swiper-slide" key={`${image.Image}-${index}`}>
                <div className={`slider-home2 ${index === 0 ? "img-animation wow" : ""}`}>
                  <img
                    alt={image.Title}
                    src={src}
                    width={960}
                    height={730}
                  />
                </div>
              </SwiperSlide>
              )
            })}
            
          </Swiper>
        )}
      </div>
    </section>
  );
}
